module.exports = __webpack_public_path__ + "img/app_alarm.17684fb6.svg";